// extracted by mini-css-extract-plugin
module.exports = {"container":"onfido-sdk-ui-CustomFileInput-container","input":"onfido-sdk-ui-CustomFileInput-input"};